const refer = {
  get (question) {
    let list = []
    if (question.type === 'select') {
      question.options.forEach((option) => {
        list = list.concat(option.referIds)
      })
    } else {
      list = list.concat(question.referIds)
    }
    return list
  },
  /**
   * 清空题目参考ID
   * @param data
   * @param questionId
   * @returns {*}
   */
  empty (data, questionId) {
    if (data.type === 'select' && data.options) {
      data.options.forEach((option) => {
        this.empty(option, questionId)
      })
    } else {
      let index = data.referIds.indexOf(questionId)
      if (index !== -1) {
        data.referIds.splice(index, 1)
      }
    }

    return data
  }
}

export default refer



// WEBPACK FOOTER //
// ./src/views/question-editor/utils/refer.js